import {
  IsEmail,
  IsNumber,
  IsNumberString,
  IsOptional,
  Matches
} from 'class-validator';
import { GiftCardMediumEnum } from './giftCardMedium.enum';

export class GiftCardBalanceRequestDto {
  cardNumber: number;

  // NOTE: This is a backwards compatibility property.
  @IsOptional()
  @IsNumber()
  giftCardMedium?: GiftCardMediumEnum | null;

  // NOTE: This is a backwards compatibility property.
  @IsOptional()
  @IsEmail()
  customerEmail?: string | null;

  @IsOptional()
  @IsNumberString()
  @Matches(/^\d{3}$/)
  cvvCode?: number | null;

  @IsNumber()
  @IsOptional()
  merchantId: number;

  captchaValue?: string | null;

  constructor() {}
  /**
   * Sets values for the object.
   */
  from(from: {
    cardNumber: number;
    giftCardMedium?: number;
    customerEmail?: string;
    cvvCode?: number;
    merchantId?: number;
    captchaValue?: string;
  }) {
    this.cardNumber = from.cardNumber;
    this.giftCardMedium = from?.giftCardMedium;
    this.customerEmail = from?.customerEmail;
    this.cvvCode = from?.cvvCode;
    this.merchantId = from?.merchantId;
    this.captchaValue = from?.captchaValue;
  }
}
